import React from 'react'

const ArrowDown = ({open=false}) => {
  return (
      <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: open ? 'rotate(-90deg)' : 'rotate(0deg)' }}
      >
          <path
              d="M11.6888 8.68018H17.9188C18.4318 8.68018 18.6926 9.30202 18.3337 9.66812C18.3334 9.6685 18.333 9.66887 18.3326 9.66925L15.1252 12.8766L13.1552 14.8466C12.5205 15.4814 11.4871 15.4814 10.8523 14.8466L5.67233 9.66662C5.30638 9.30068 5.56553 8.68018 6.07877 8.68018H11.6888Z"
              fill="#808080"
              stroke="#808080"
          />
      </svg>
  );
}

export default ArrowDown
